module.exports = __webpack_public_path__ + "img/crmUse.5f8b69df.png";